/**
 * Utility service for managing redirect URLs after authentication
 */

const REDIRECT_STORAGE_KEY = 'redirectAfterAuth';

export const redirectService = {
  /**
   * Save the redirect URL to localStorage
   * @param url - The URL to redirect to after authentication
   */
  saveRedirect: (url: string): void => {
    try {
      if (typeof window !== 'undefined') {
        localStorage.setItem(REDIRECT_STORAGE_KEY, url);
      }
    } catch (error) {
      console.error('Failed to save redirect URL:', error);
    }
  },

  /**
   * Get the saved redirect URL from localStorage
   * @param defaultUrl - The default URL to return if no redirect is saved
   * @returns The saved redirect URL or the default URL
   */
  getRedirect: (defaultUrl: string = '/'): string => {
    try {
      if (typeof window !== 'undefined') {
        return localStorage.getItem(REDIRECT_STORAGE_KEY) || defaultUrl;
      }
    } catch (error) {
      console.error('Failed to get redirect URL:', error);
    }
    return defaultUrl;
  },

  /**
   * Clear the saved redirect URL from localStorage
   */
  clearRedirect: (): void => {
    try {
      if (typeof window !== 'undefined') {
        localStorage.removeItem(REDIRECT_STORAGE_KEY);
      }
    } catch (error) {
      console.error('Failed to clear redirect URL:', error);
    }
  },

  /**
   * Get the redirect URL and clear it from localStorage
   * @param defaultUrl - The default URL to return if no redirect is saved
   * @returns The saved redirect URL or the default URL
   */
  getAndClearRedirect: (defaultUrl: string = '/'): string => {
    const url = redirectService.getRedirect(defaultUrl);
    redirectService.clearRedirect();
    return url;
  },
};
